<template>
  <div class="bqsm">
    <div class="docs-header">版权声明：</div>
    <div class="container">
      <div class="content">弈小象所有发布的作品（包括但不限于课程视频、音频、课件、教材、题目等）著作权及邻接权归北京童心弈智教育科技有限公司所有，受各国版权法及国际版权公约的保护。弈小象所有在线课程只允许购买者在线观看学习，不可销售、传播。对于上述版权内容，超越合理使用范畴并未经本公司书面许可的使用行为，我公司均保留追究法律责任的权利。</div>
      <div class="title">反盗链声明：</div>
      <div class="content">本公司已经对本应用程序内全部视频内容采取了必要的反盗版和防盗链等技术措施，并且添加、设置权利管理电子信息。 任何单位或个人，未经本公司许可，不得以任何方式（包括但不限于：盗链、冗余盗取等）直接或间接地盗取相关视频内容、不得以任何方式（包括但不限于：隐藏或者修改本网站域名、播放器软件、标识等）删除或者改变相关视频内容的权利管理电子信息。本公司将保留进一步追究侵权者法律责任的权利。</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bqsm'
}
</script>

<style scoped lang="scss">
  @import "../assets/scss/base.scss";
  @import "../assets/scss/mixin.scss";
  @import "../assets/scss/config.scss";
  .yssm{
    width: 100%;
    @media only screen and (min-width: 540px) and (max-width: 1180px){
      width: 1180px;
    }
  }
  .docs-header{
    font-family:microsoft yahei;
    font-size: 36px;
    font-weight: bold;
    position: relative;
    padding: 60px 0;
    text-align: center;
    text-shadow: 0 1px 0 rgba(0,0,0,.1);
    background-color: #f2f9fe;
    border-bottom: 1px solid #e9f0f3;
  }
  .continer{
    width: 100%;
    padding: 20px;
    box-sizing: border-box;
  }
  .content{
    width: 100%;
    font-family:microsoft yahei;
    font-size: 20px;
    line-height: 60px;
    letter-spacing: 5px;
  }
  .title{
    width: 100%;
    font-family:microsoft yahei;
    font-size: 36px;
    font-weight: bold;
    margin: 30px 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/bqsm.vue